import { useTranslations } from "next-intl";
import { useCallback } from "react";
import { css } from "styled-system/css";

import { toast } from "@/components/toast";
import { KEYLESS_ACCOUNT_EXPIRED_ERROR_KEY } from "@/constants";
import { getErrorMessage } from "@/utils/error";
import { openKeylessWindow } from "@/utils/keyless/window";

import { useKeylessAccounts } from "./use-keyless-accounts";

// @Todo: Use this later to show better error messages based on contract error codes
export const useTransactionErrorToast = () => {
  const t = useTranslations("keyless");
  const tGeneral = useTranslations("general");
  const { activeKeyless } = useKeylessAccounts();

  return useCallback(
    (error: unknown, defaultDescription?: string, defaultTitle?: string) => {
      const isKeylessAccountExpired =
        getErrorMessage(error) === KEYLESS_ACCOUNT_EXPIRED_ERROR_KEY && activeKeyless;

      toast({
        onClick: isKeylessAccountExpired
          ? () => openKeylessWindow(activeKeyless.provider, false, activeKeyless.email)
          : undefined,
        title: defaultTitle ?? tGeneral("error"),
        description: isKeylessAccountExpired
          ? () => (
              <span>
                {t("accountExpiredError.1")}{" "}
                <span
                  className={css({
                    textDecoration: "underline",
                    textUnderlineOffset: "2",
                  })}
                >
                  {t("accountExpiredError.2")}
                </span>{" "}
                {t("accountExpiredError.3")}
              </span>
            )
          : (defaultDescription ?? ""),
        variant: "error",
      });
    },
    [tGeneral, t, activeKeyless],
  );
};
